export default {
  contracts: {
    activeContracts: '활성 계약',
    productsAndHours: '해당 제품 및 남은 지원 시간',
    supported: '지원됨',
    notSupported: '지원되지 않음',
    contact: '계정 관리자'
  },
  states: {
    OPEN: '열린',
    AWAITING_REPLY: '회신을 기다리는',
    CLOSED: '닫은',
    FEEDBACK_REQUIRED: '피드백 필요',
    onlyRequired: '필요한 작업 만 표시',
    onlyWorkRequests: '작업 요청 승인만 표시'
  },
  common: {
    New: '새로운',
    Open: '열린',
    Pending: '계류중인',
    Closed: '닫은',
    create: '창조하다',
    cancel: '취소',
    goBack: '돌아 가기',
    close: '닫기',
    goToMain: '메인 페이지로 이동'
  },
  property: {
    name: '재산',
    allProperties: '모든 재산',
    selectProperty: '재산 선택'
  },
  product: {
    name: '제품',
    allProducts: '모든 제품',
    selectProduct: '제품 선택',
    goBack: '돌아 가기',
    noProducts: '제품 없습니다'
  },
  chart: {
    chooseMonth: '월 선택',
    noData: '현재 기간에 대한 데이터가 없습니다.'
  },
  navigation: {
    main: '메인',
    interactions: '티켓',
    contracts: '계약',
    signOut: '로그 아웃'
  },
  tickets: {
    createNewTitle: '새 티켓 만들기',
    title: '표제',
    noTickets: '현재 필터가 미리 설정된 티켓이 없습니다.',
    search: '검색',
    createNew: '새로 만들기',
    reopenOrDisagree: '동의하지 않는다',
    escalation: '관리자에게 전달',
    reason: '이유',
    reopen: '티켓 재 개설',
    escalate: '관리자에게 전달',
    opinionTitle: '귀하의 의견은 우리에게 중요합니다.',
    opinionBody: '직원들의 업무를 평가 해주세요.',
    time: '해결 시간',
    qualification: '기술 자격',
    communication: '의사 소통 능력',
    sendFeedback: '의견 보내기',
    leaveFeedback: '피드백 남기기',
    close: '닫기',
    alreadyHasFeedback: '티켓에 이미 의견이 있습니다.',
    feedbackHasBeenSent: '의견이 전송되었습니다.',
    ticketHasBeenReopened: '티켓이 재개되었습니다.',
    ticketHasBeenEscalated: '티켓이 이관되었습니다.',
    comment: '논평',
    keyPlaceholder: '메시지 입력',
    approve: '승인하다',
    reject: '거절된 사람',
    workRequestOnContractNotification:
      '{{fullName}}님,\n\n현재 귀하의 지원 계약에는 {{hoursInSupportContract}}시간의 부가 가치 서비스가 포함되어 있습니다.\n{{workRequestId}} 티켓을 완료하려면 {{hoursRequested}}시간이 필요합니다. \n\n위 작업의 잔액에서 시간을 공제하는 것을 승인해 주십시오.\n감사합니다\n\n감사합니다.\n{{author}}',
    workRequestChargeableNotification:
      '{{fullName}}님께,\n\n이 작업은 서비스에 포함되지 않거나 계약에 따라 보장되지 않습니다. 기꺼이 일정을 계획하고 도와드리겠습니다. {{workRequestId}} 요청을 완료하는 데 {{hoursRequested}}시간이 소요될 것으로 예상됩니다.\n\n이 요청을 완료하는 데 드는 비용은 {{amount}}입니다.\n이 제안은 발행일로부터 7일 이내에 유효합니다. \n실제 소요 시간이 원래 견적을 초과하는 경우 추가 시간에 대한 추가 요청 양식이 승인을 위해 요청자에게 전송됩니다. 예상 시간이 원래 견적보다 적으면 원래 견적이 취소되고 수정된 견적이 적용됩니다. 보내드립니다.\n\n추가 작업 및 비용을 승인해 주시기 바랍니다.\n\n감사합니다.\n{{author}}',
    workRequestCommentRequired: '채용 요청을 거부하는 이유를 입력하세요.'
  },
  severity: {
    name: '심각도',
    0: '정상',
    1: '높은',
    2: '극히 높은'
  },
  forms: {
    password: '비밀번호',
    confirmPassword: '비밀번호 확인',
    passwordsDoNotMatch: '비밀번호가 일치하지 않습니다',
    updatePassword: '비밀번호 업데이트',
    askRestore: '비밀번호 업데이트 요청',
    remember: '비밀번호 기억하기',
    restorePassword: '비밀번호 복원',
    signIn: '로그인'
  },
  transactions: {
    date: '날짜',
    type: '종류',
    comment: '논평',
    status: '상태',
    subject: '작업 요청',
    name: '거래 목록',
    hours: '시간',
    viewTransactions: '거래보기',
    types: {
      WORK_REQUEST: '작업 요청',
      CONTRACT_ACTIVATION: '계약 활성화',
      CONTRACT_EXPIRATION: '계약 만료',
      MANUAL_ADJUST_ADD: '조정 - 더 추가',
      MANUAL_ADJUST_DEDUCT: '조정 - 줄이다',
      TRANSFER_PROPERTY: '부동산 양도',
      TRANSFER_PRODUCT: '제품 이전'
    }
  },
  transactionDetail: {
    name: '상세 거래 내역',
    num: '번호',
    insertTime: '제작 날짜',
    requestorName: '요청자',
    subject: '제목',
    status: '상태',
    acceptTime: '수령 날짜',
    cancelTime: '취소 날짜',
    hours: '시간',
    hourType: '시간 종류',
    workText: '작업 설명',
    plannedDate: '계획된 날짜'
  },
  statuses: {
    Approved: '승인 됨',
    Pending: '대기중인',
    Cancelled: '취소 된'
  },
  hoursTypes: {
    'Included in contract': '계약서에 포함됨',
    'Installation hours': '설치 시간',
    'Preventative visit': '예방 방문',
    Chargeable: '청구 가능'
  },
  errors: {
    unknown: '알 수없는 오류 메시지',
    1000: '오류 메시지 요청',
    1001: '오류 메시지 요청',
    1: '로그인 또는 비밀번호가 잘못되었습니다',
    2: '세션이 만료되었습니다.',
    3: '알 수없는 재산',
    4: '알 수없는 제품',
    7: '알 수없는 상호 작용',
    8: '상호 작용이 이미 닫혔습니다.',
    11: '액세스 위반',
    12: '알 수없는 작업 요청'
  }
}
